import { Component, inject } from '@angular/core';

import * as clientVersion from '../../../git-version.json';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ServerVersionComponent } from '../server-version-component/server-version-component';

@Component({
  selector: 'app-client-version-component',
  imports: [MatDialogModule],
  standalone: true,
  templateUrl: './client-version-component.html',
  styleUrl: './client-version-component.scss',
})
export class ClientVersionComponent {
  clientVersion = clientVersion;

  dialog = inject(MatDialog);

  versionInfo(): string {
    return clientVersion.semverString ? clientVersion.semverString : clientVersion.suffix;
  }

  openServerInfoDialog(): void {
    this.dialog.open(ServerVersionComponent, {});
  }
}
